import React from 'react';
const Notfind = () => {
  return (
    <div className="notfind">
      <p>검색된 매장이 없습니다.</p>
    </div>
  );
};
const StoreAddress = ({ store }) => {
  return (
    <li>
      <strong>{store.CPNM}</strong>
      <p>{store.ADDRESS}</p>
    </li>
  );
};
const StoreList = ({ store_list }) => {
  return (
    <div className="store_list_box">
      {store_list.length === 0 ? (
        <Notfind />
      ) : (
          <ul>
            {store_list.map((store, index) => (
              <StoreAddress store={store} key={index} />
            ))}
          </ul>
        )}
    </div>
  );
};

export default StoreList;
